
export default "/assets/chart-bar-mini.3b3b607b.svg"